// extracted by mini-css-extract-plugin
export default {"option":"rY9Yd7p7","isSelected":"E0zVQCwq","colorList":"W8ew_RAB","colorItem":"fNSq9vYt"};